module.exports = __webpack_public_path__ + "img/17.aef56279.jpg";